<template>
<div>Идет загрузка</div>
</template>

<script>
export default {
  name: 'cabinet',
  props: ['city', 'auth', 'basket', 'geo', 'user'],
  created () {
    if (this.auth.uid) this.loadCabinet()
    else {
      setTimeout(() => {
        if (this.auth.uid) this.loadCabinet()
      }, 100)
    }
  },
  methods: {
    loadCabinet () {
      if (this.user.access) {
        if (this.user.access === 'user') this.$router.push('/profile')
        else this.$router.push('/lk')
      } else setTimeout(() => { this.loadCabinet() }, 500)
    }
  },
  watch: {
    $route (to, from) {
      this.loadCabinet()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/lk/cabinet.vue